import { render } from "./PriceList.vue?vue&type=template&id=65b12da5"
import script from "./PriceList.vue?vue&type=script&lang=js"
export * from "./PriceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Terms/PriceList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65b12da5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65b12da5', __exports__)) {
    api.reload('65b12da5', __exports__)
  }
  
  module.hot.accept("./PriceList.vue?vue&type=template&id=65b12da5", () => {
    api.rerender('65b12da5', render)
  })

}


export default __exports__